import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

/**
 * @deprecated - [fabric-deprecated] - Use event bus retrieve with AccountAppValue instead
 */
@Injectable({ providedIn: "root" })
export class DepositThresholdService {
	constructor(private httpClient: CoreHttpClient) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use event bus retrieve with AccountAppValue.FetchThresholdStatus instead
	 */
	hasReachedThreshold(): Observable<boolean> {
		return this.httpClient.get<boolean>({ url: "v1/segob/currentcustomerlimits/depositlimit/threshold-reached" });
	}
}
